import { get, post, del, put } from '../request';

export async function fetchVersionList(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/versionlist/${propertyId}/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchVersion(
  { equityfinderService },
  authenticationToken,
  { versionId, sortField },
) {
  let url = `${equityfinderService}/equityfinder/property/version/${versionId}`;
  if (sortField) {
    url += `?sortField=${sortField}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createVersion(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/versionlist/${propertyId}/${year}`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function removeVersion(
  { equityfinderService },
  authenticationToken,
  { versionId },
) {
  const url = `${equityfinderService}/equityfinder/property/version/${versionId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function setVersionActive(
  { equityfinderService },
  authenticationToken,
  { versionId, propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/version/default`;
  const { body } = await put(authenticationToken, url, {
    versionID: versionId,
    propID: propertyId,
    year,
  });
  return body;
}

export async function addPropertyToVersion(
  { equityfinderService },
  authenticationToken,
  { versionId, propertyId },
) {
  const url = `${equityfinderService}/equityfinder/property/version/${versionId}`;
  const { body } = await post(authenticationToken, url, {
    compPropID: propertyId,
  });
  return body;
}

export async function removePropertyFromVersion(
  { equityfinderService },
  authenticationToken,
  { compId },
) {
  const url = `${equityfinderService}/equityfinder/property/version/comp/${compId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function copyPropertyToVersion(
  { equityfinderService },
  authenticationToken,
  { versionId, propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/version/${versionId}/copyversion`;
  const { body } = await post(authenticationToken, url, {
    propID: propertyId,
    year,
  });
  return body;
}

export async function importPropertyToVersion(
  { equityfinderService },
  authenticationToken,
  { versionId, propertyId },
) {
  const url = `${equityfinderService}/equityfinder/property/version/${versionId}/copymaster `;
  const { body } = await post(authenticationToken, url, { propID: propertyId });
  return body;
}

export async function versionCompPropertiesSelect(
  { equityfinderService },
  authenticationToken,
  { versionId, propertyIds },
) {
  const url = `${equityfinderService}/equityfinder/property/version/${versionId}/bulk`;
  const { body } = await post(authenticationToken, url, {
    propIDList: propertyIds,
  });
  return body;
}

export async function updateVersionDescription(
  { equityfinderService },
  authenticationToken,
  { versionId, description },
) {
  const url = `${equityfinderService}/equityfinder/property/version/${versionId}`;
  const { body } = await put(authenticationToken, url, { description });
  return body;
}
